///Bug resolve azure-400

import { useState, useEffect, Fragment, FC } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup
} from "@mui/material";
import { FormDataType } from "DataTypes/Form";
import {
  CPAPCMSummaryType,
  CPSummaryV3Type,
  TCMSummaryV2Type,
} from "DataTypes/Services/Careplan.type";
import CarePlanApi from "Service/CarePlan.api";
import CPFormatter from "Utils/CP.Formatter";
import { Arr, Arr1 } from "./Data";
import { commonFormSwitch } from "Utils/SwitchCases";
import Loader from "Components/Loader";
import DateTime from "Utils/DateTime";
import {
  ListInitialStateType,
  PatientInitialStateType,
  UserInitialStateType,
} from "DataTypes/Redux";
import { useSelector } from "react-redux";
import SummaryView from "Components/Summary";
import TCMSummaryView from "Components/Summary/TCM";
import { CMTabSelectedEnrollmentType } from "DataTypes/Modal";
import ImgPath from "Constant/Imgs";
import PatientApi from "Service/Patient.api";
import { useNavigate, useParams } from "react-router-dom";
import { RouteUrls } from "Constant/RouteUrls";
import CstmIconBtn from "Components/CstmIconBtn";
import { useDispatch } from "react-redux";
import { addSelectedPrgm } from "Redux/Patient/Action";
import { selectedPrgmInitialState } from "Redux/Patient/reducer";
import PatientFormatter from "Utils/Patient.Formatter";
import { CheckNumber, CheckStringEmpty } from "Utils/common";
import { CPPAPType, ReadOnlyType } from "DataTypes/PatientManagement.type";
import Stages from "Constant/Stages";
import APCMSummaryView from "Components/Summary/APCM";
import { setAlertData } from "Redux/Screen/Action";
import PreApprovedPlanApi from "Service/PreApprovedPlan.api";
import PreApprovedPlanFormatter from "Utils/PreApprovedPlan.Formatter";

const CarePlan: FC<CMTabSelectedEnrollmentType> = ({
  prgmDetails,
  onClose,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patientId } = useParams();
  const { frequencyList, rpmFrequencyList }: ListInitialStateType = useSelector(
    (state: any) => state?.list
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const { ehr }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const {
    careplanId,
    abbrevation,
    isCareplanComprehensive,
    teamMember,
    status,
    seniorTeamMember,
    careplanRecurringId
  } = prgmDetails;
  const isAdmin = myInfo.roleId == 1 || myInfo.roleId == 2;
  const [formData, setFormData] = useState<FormDataType[]>(Arr);
  const [formData1, setFormData1] = useState<FormDataType[]>(Arr1);
  const [loading, setLoading] = useState(true);
  const [summaryV3, setSummaryV3] = useState<CPSummaryV3Type[]>([]);
  const [tcmV2, setTCMV2] = useState<TCMSummaryV2Type | null>(null);
  const [apcmSummary, setAPCMSummary] =
    useState<CPAPCMSummaryType | null>(null);
  const [chronicType, setChronicType] = useState<string | null>(null);
  const [papSummary, setPAPSummary] = useState<CPPAPType[]>([]);

  const crudPermission = ehr.vendor === null;
  let displayEditBtn = crudPermission;
  if (prgmDetails.abbrevation == "TCM") displayEditBtn = false;
  else if (prgmDetails.status != "Enrolled") displayEditBtn = false;
  else if (
    prgmDetails.careplanStage == 9 &&
    !(prgmDetails.seniorTeamMember || isAdmin)
  ) displayEditBtn = false;
  else if (
    prgmDetails.careplanStage > 9 &&
    !(prgmDetails.teamMember || isAdmin)
  ) displayEditBtn = false;

  let updateChronicType = false;
  if (crudPermission && status == "Enrolled") {
    if (isAdmin) updateChronicType = true;
    else if (seniorTeamMember) updateChronicType = true;
    else if (teamMember && careplanRecurringId) updateChronicType = true;
  }

  useEffect(() => {
    handleReadApiCalls();
    handlePAPSummary();
  }, []);

  const handleReadApiCalls: () => void = async () => {
    const newFormData = structuredClone(formData);
    const newFormData1 = structuredClone(formData1);
    const searchRes = await CarePlanApi.search({ id1: careplanId });
    if (searchRes?.success) {
      const FormatedRes = CPFormatter.CheckCPSearch(searchRes?.data);
      if (isCareplanComprehensive) {
        newFormData1[0].label = "Message";
        newFormData1[0].value = FormatedRes.message;
        newFormData1[0].readOnly = true;
        newFormData[0].multilineRows = 20;
      }
      newFormData[0].value = FormatedRes.carePlanAdditionalNotes;
      newFormData[1].value = newFormData[1].dropValue =
        FormatedRes.careplan_frequency;
      newFormData[2].value = DateTime.UTCToLocalDateTime(
        FormatedRes.careplanCompletionDate
      );
    }
    if (abbrevation == "TCM") {
      //TCM summary Implementation
      const TcmSearchRes = await CarePlanApi.TCMSummaryV2({
        id1: careplanId,
      });
      if (TcmSearchRes?.success)
        setTCMV2(CPFormatter.TCMV2Summary(TcmSearchRes?.data));
    } else if (abbrevation == "APCM") {
      const sumRes = await CarePlanApi.CPAPCMSummary({ id1: careplanId });
      if (sumRes?.success) {
        const newData = CPFormatter.CPAPCMSummary(sumRes?.data);
        setAPCMSummary(newData);
      }
    } else {
      const sumRes = await CarePlanApi.CPSummaryV3({ id1: careplanId });
      if (sumRes?.success) setSummaryV3(CPFormatter.CPV3Summary(sumRes?.data));
    }
    if (abbrevation == "APCM") {
      const chronicTypeRes =
        await CarePlanApi.CPChronicTypeSearch({ id1: careplanId });
      if (chronicTypeRes?.success) {
        setChronicType(
          CheckStringEmpty(chronicTypeRes?.data?.chronicType) || null
        );
      }
    }
    newFormData[1].dropArr =
      abbrevation == "RPM" ? rpmFrequencyList : frequencyList;
    newFormData[0].readOnly =
      newFormData[1].readOnly =
      newFormData[2].readOnly =
      true;
    setFormData(newFormData);
    setFormData1(newFormData1);
    setLoading(false);
  };

  const handlePAPSummary: () => void = async () => {
    const res = await PreApprovedPlanApi.PAPSummary({ id1: careplanId });
    if (res?.success) {
      const newData = PreApprovedPlanFormatter.PAPSummary(res?.data);
      setPAPSummary(newData);
    }
  }

  const handleRevisionInitiate: (type: string) => void = async (type) => {
    setLoading(true);
    const payload = {
      id1: careplanId,
    };
    const res: any = await PatientApi.RevisionInitiate(payload);
    if (res?.success) {
      const careId = CheckNumber(res?.data?.id) || null;
      if (careId) {
        const careplanstate = CheckStringEmpty(res?.data?.carePlanState) || "";

        const callDefaultRoute = `../${RouteUrls.revisionPlan}/` +
          `${careId}/${PatientFormatter.StateRouteSwitch(careplanstate)}`;
        dispatch(
          addSelectedPrgm({
            ...selectedPrgmInitialState,
            ...prgmDetails,
            ...(myInfo.roleId == 3 &&
              PatientFormatter.GetCPStage(careplanstate) > 7
              ? { showSubmitBtn: false }
              : {}),
            billableproviderId: prgmDetails.billableproviderId,
            callDefaultRoute: callDefaultRoute,
            caremanagerId: prgmDetails.caremanagerId,
            careplanCreatedInEhr: "no",
            careplanId: careId,
            careplanInitDateInEhr: "",
            careplanRecurringId: null,
            careplanStage: PatientFormatter.GetCPStage(careplanstate),
            careplanState: careplanstate,
            careplanType: "REVISION",
            isCareplanComprehensive: false,
            providerId: prgmDetails.providerId,
            readOnlyArr: ["care-team", "editDevice"],
            showLogTime: true,
            showSaveBtn: true,
            showSubmitBtn: true,
            teamInitiatedBy: myInfo.id,
            teamInitiatorRoleId: myInfo.roleId,
          })
        );

        if (type === "start") {
          navigate(
            `../${RouteUrls.patient}/${patientId}/${RouteUrls.revisionPlan
            }/${careId}/${PatientFormatter.StateRouteSwitch(careplanstate)}`
          );
        } else {
          navigate(`../${RouteUrls.patient}/${patientId}/${RouteUrls.callLog}`);
        }
        onClose && onClose();
      } else {
        dispatch(setAlertData({
          alertMessage: res?.alert?.alertMessage || "Revision not found",
          alertVariant: "info",
          openAlert: true
        }))
      }
    }
    setLoading(false);
  };

  const handleEditCarePlan: () => void = () => {
    onClose && onClose();
    const defaultArr: ReadOnlyType[] = [
      "uptoDate",
      "problem",
      "question",
      "care-team",
      "add-provider",
      "edit-provider",
      "interactive",
      "medically",
    ];
    prgmDetails.careplanState == Stages.Recurring &&
      defaultArr.push("addNotes", "addDevice", "editDevice");
    dispatch(
      addSelectedPrgm({
        ...selectedPrgmInitialState,
        ...prgmDetails,
        readOnlyArr: defaultArr,
        showSaveBtn: true,
        ...(prgmDetails.abbrevation == "RPM" &&
          PatientFormatter.GetCPStage(Stages.Recurring) >
          prgmDetails.careplanStage
          ? { showLogTime: true }
          : {}),
      })
    );
    navigate(
      `/${RouteUrls.hs}/${RouteUrls.patient}/${patientId}/` +
      `${prgmDetails.abbrevation == "RPM"
        ? RouteUrls.treatmentPlan
        : RouteUrls.carePlan
      }/${prgmDetails.careplanId}/${RouteUrls.careSummary}`
    );
  };

  const handleChronicType: (val: string) => void = async (val) => {
    const res = await CarePlanApi.CPChronicTypeUpdate({
      id1: careplanId,
      data: { chronicType: val, careplanId: careplanId, },
    });
    if (res?.success) {
      setChronicType(val);
      dispatch(setAlertData({
        alertMessage:
          "The appropriate HCPCS code has been selected.",
        alertVariant: "success",
        openAlert: true
      }))
    }
  };

  const ChronicTypeUI = (
    <FormControl>
      <FormLabel
        id="demo-controlled-radio-buttons-group"
        sx={{ fontWeight: "bold", fontSize: "0.85rem", my: 1, }}
      >
        Select which is applicable for the patient.
      </FormLabel>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
        onChange={(e) => handleChronicType(e.target.value)}
        value={chronicType}
        sx={{
          "& >label": {
            "&>span": { fontSize: "0.85rem" }
          }
        }}
      >
        <FormControlLabel
          value="One Chronic"
          control={
            <Radio
              color="secondary"
              size="small"
              disabled={!updateChronicType}
            />
          }
          label="The patient has 0 or 1 chronic condition."
        />
        <FormControlLabel
          value="Two Chronic"
          control={
            <Radio
              color="secondary"
              size="small"
              disabled={!updateChronicType}
            />
          }
          label="The patient has 2 or more chronic conditions."
        />
        <FormControlLabel
          value="QMB"
          control={
            <Radio
              color="secondary"
              size="small"
              disabled={!updateChronicType}
            />
          }
          label="The patient is a Qualified Medicare Beneficiary (QMB)."
        />
      </RadioGroup>
    </FormControl>
  )

  const ComprehensiveUI = (
    <Fragment>
      <Box display={"flex"} mb={2}>
        <Box width="100%">
          <Box width="100%">
            {formData1.slice(0, 1).map(formEl => {
              return commonFormSwitch({ formObj: formEl })
            })}
          </Box>
          <Box display="flex" mt={1}>
            <Box width="70%" mr={1}>
              {formData.slice(0, 1).map(formEl => {
                return commonFormSwitch({ formObj: formEl })
              })}
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              // justifyContent="space-between"
              width="30%"
            >
              {formData.slice(1).map(formEl => {
                return (
                  <Box key={formEl.id}>
                    {commonFormSwitch({ formObj: formEl })}
                  </Box>
                )
              })}
            </Box>
          </Box>
        </Box>
        <Box display={"flex"} justifyContent={"flex-end"} width={"10%"} mt={2}>
          {crudPermission &&
            (abbrevation == "RPM" || abbrevation == "APCM") &&
            prgmDetails.status == "Enrolled" &&
            prgmDetails.careplanStage == 10 &&
            prgmDetails.seniorTeamMember && (
          //For RPM Program
            <Fragment>
              <CstmIconBtn
                icon={<ImgPath.CarePlanIcon />}
                onClick={() => handleRevisionInitiate("start")}
                title="Start Treatment Plan Revision"
                sxProps={{ mr: 1 }}
              />
              <CstmIconBtn
                icon={<ImgPath.CallIcon />}
                onClick={() => handleRevisionInitiate("call")}
                title="Call"
                sxProps={{ mr: 1 }}
              />
            </Fragment>
          )}
          {displayEditBtn && (
            <CstmIconBtn
              icon={<ImgPath.EditOutlined />}
              onClick={handleEditCarePlan}
              title="Edit"
              sxProps={{ mr: 1 }}
            />
          )}
        </Box>
      </Box>
      {abbrevation == "APCM" && ChronicTypeUI}
    </Fragment>
  );

  const NonComprehensiveUI = (
    <Box display="flex"
      flexDirection="row"
      height="100%"
      justifyContent="space-between"
    >
      <Box width="75%" height="100%" overflow="auto">
        {abbrevation == "TCM" ? (
          <TCMSummaryView summary={tcmV2} />
        ) : abbrevation == "APCM" && apcmSummary ? (
          <APCMSummaryView summary={apcmSummary} />
        ) : (
          <SummaryView summary={summaryV3} papSummary={papSummary} />
        )}
      </Box>

      <Box
        width="24%"
        sx={{
          "&>div:first-of-type": { mb: 1 },
          overflowY: "auto", overflowX: "hidden"
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          {crudPermission &&
            (abbrevation == "RPM" || abbrevation == "APCM") &&
            prgmDetails.status == "Enrolled" &&
            prgmDetails.careplanStage == 10 &&
            prgmDetails.seniorTeamMember && (
          //For RPM Program
            <Fragment>
              <CstmIconBtn
                icon={<ImgPath.CarePlanIcon />}
                onClick={() => handleRevisionInitiate("start")}
                title="Start Treatment Plan Revision"
                sxProps={{ mr: 1 }}
              />
              <CstmIconBtn
                icon={<ImgPath.CallIcon />}
                onClick={() => handleRevisionInitiate("call")}
                title="Call"
                sxProps={{ mr: 1 }}
              />
            </Fragment>
          )}
          {displayEditBtn && (
            <CstmIconBtn
              icon={<ImgPath.EditOutlined />}
              onClick={handleEditCarePlan}
              title="Edit"
              sxProps={{ mr: 1 }}
            />
          )}
        </Box>
        {formData.map((formEl) => {
          if (abbrevation == "TCM" && formEl.id == "call-freq") {
            return <></>;
          }
          return (
            <Fragment key={formEl.id}>
              {commonFormSwitch({ formObj: formEl })}
            </Fragment>
          );
        })}
        {abbrevation == "APCM" && ChronicTypeUI}
      </Box>
    </Box>
  );

  if (loading) return <Loader />;

  if (isCareplanComprehensive) return ComprehensiveUI;
  else return NonComprehensiveUI;
};
export default CarePlan;
